export const actions = {
  /**
   * Send add favourite request
   *
   * @param {Object} context
   * @param {Object} user
   */
  async sendAddFavouritesRequest(context, user) {
    // Step 1: Data sanitization
    if (!user) {
      return false;
    }

    // Step 2: Create default request
    let request = false;

    // Step 3: Create the request according to the type
    if (user.type === "group_appointment") {
      request = {
        groupappointment_id: user.id,
        otherevent_id: 0,
        person_id: 0
      };
    } else if (user.type === "other_event") {
      request = {
        otherevent_id: user.id,
        person_id: isNaN(user.user_id) ? 0 : parseInt(user.user_id),
        groupappointment_id: 0
      };
    } else {
      request = {
        otherevent_id: 0,
        person_id: user.id,
        groupappointment_id: 0
      };
    }

    // Step 4: Add the user to the loading list
    context.commit("addSendingFavRequest", user.type + user.id);

    // Step 5: Send the request
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "favourite/add",
        method: "POST",
        data: request
      },
      { root: true }
    );

    // Step 6: State management after added as favourite in form list
    context.commit(
      "addOrRemoveFavourites",
      {
        user: user,
        res: json,
        addOrRemove: "ADD"
      },
      { root: true }
    );
    if (user.type === "person") {
      // Add to the clients list as well
      context.commit(
        "clients/addOrRemoveFavourites",
        {
          user: user,
          res: json,
          addOrRemove: "ADD"
        },
        { root: true }
      );
    }
    if (request.person_id !== 0 || request.groupappointment_id !== 0) {
      // Add to chat friend list favourite, if present
      context.commit(
        "chat/addOrRemoveFavourites",
        {
          user: { ...user, person_id: request.person_id },
          res: json,
          addOrRemove: "ADD",
          isGroup: user.type === "group_appointment"
        },
        { root: true }
      );
    }

    // Step 7: Remove the user from the loading list
    context.commit("removeSendingFavRequest", user.type + user.id);
  },

  /**
   * Remove an user from the favourite list
   *
   * @param {Object} context
   * @param {Object} user
   */
  async sendRemoveFavouritesRequest(context, user) {
    // Step 1: Data sanitization
    if (!user) {
      return false;
    }

    // Step 2: Create default request
    let request = {
      id: user.favourite_id
    };

    // Step 3: Add the user to the loading list
    context.commit("addSendingFavRequest", user.type + user.id);

    // Step 4: Send the request
    await context.dispatch(
      "makeAuthRequest",
      {
        url: "favourite/delete",
        method: "DELETE",
        data: request
      },
      { root: true }
    );

    // Step 5: State management after added as favourite
    context.commit(
      "addOrRemoveFavourites",
      {
        user: user,
        res: false,
        addOrRemove: "REMOVE"
      },
      { root: true }
    );
    if (user.type === "person") {
      context.commit(
        "clients/addOrRemoveFavourites",
        {
          user: user,
          res: false,
          addOrRemove: "REMOVE"
        },
        { root: true }
      );
    }
    if (user.type === "other_event") {
      const userId = isNaN(user.user_id) ? 0 : parseInt(user.user_id);
      if (userId !== 0) {
        // Remove from chat friend list favourite, if present
        context.commit(
          "chat/addOrRemoveFavourites",
          {
            user: { ...user, person_id: userId },
            res: false,
            addOrRemove: "REMOVE"
          },
          { root: true }
        );
      }
    } else if (user.type === "group_appointment") {
      // Remove from chat friend list favourite, if present
      context.commit(
        "chat/addOrRemoveFavourites",
        {
          user: { ...user, person_id: user.id },
          res: false,
          addOrRemove: "REMOVE",
          isGroup: true
        },
        { root: true }
      );
    } else {
      // Remove from chat friend list favourite, if present
      context.commit(
        "chat/addOrRemoveFavourites",
        {
          user: { ...user, person_id: user.id },
          res: false,
          addOrRemove: "REMOVE"
        },
        { root: true }
      );
    }

    // Step 6: Remove the user from the loading list
    context.commit("removeSendingFavRequest", user.type + user.id);
  }
};
